// This is default list of criticality we use for non-conformities
import { getNonConformityTranslation } from "Components/Governance/Anomalies/utils.js"
export const defaultCriticalityNeedActionPlan = [
  "uuid_high_default_criticity",
  "uuid_critic_default_criticity",
]

export const getDefaultCriticalityOptions = trad => {
  if (!trad) return []
  return [
    {
      value: "uuid_veryLow_default_criticity",
      label: trad?.VERYLOW,
    },
    {
      value: "uuid_low_default_criticity",
      label: trad?.LOW,
    },
    {
      value: "uuid_moderate_default_criticity",
      label: trad?.MODERATE_FEMALE,
    },
    {
      value: "uuid_high_default_criticity",
      label: trad?.HIGH_FEMALE,
    },
    {
      value: "uuid_critic_default_criticity",
      label: trad?.CRITICAL,
    },
  ]
}

// This is custom list can business create ( based on customList routes back)
export const getCustomCriticalityOptions = customListCriticality => {
  if (!customListCriticality) return []
  const { values } = customListCriticality
  if (!Array.isArray(values)) return []
  const customCriticalityOptions = values.map(val => {
    const option = { value: val.uuid, label: val.label }
    if (val?.disabled) option.disabled = val?.disabled
    return option
  })
  return customCriticalityOptions
}

export const getCriticalityOptionsToUse = (defaultOptions, customOptions, useCustomCriticality) => {
  if (!Array.isArray(defaultOptions)) return []
  if (useCustomCriticality && Array.isArray(customOptions) && customOptions.length > 0) {
    return customOptions.filter(opt => !opt.disabled)
  }
  return defaultOptions
}

export const findSelectedCriticality = (defaultOptions, customOptions, nonConformity, trad) => {
  if (!Array.isArray(defaultOptions) || !Array.isArray(customOptions) || !nonConformity || !trad) {
    return null
  }
  const allOptions = [...defaultOptions, ...customOptions]
  const { criticalityUuid, criticality } = nonConformity
  if (!criticalityUuid && !criticality) return null
  const criticalityToUse = criticalityUuid ? criticalityUuid : criticality
  const selectedCriticality = allOptions.find(option => option?.value === criticalityToUse)
  // If we find a match we return found option
  if (selectedCriticality) return selectedCriticality
  // Else we return an object with old values and label is value translated
  const oldNonConformityTranslation = getNonConformityTranslation(trad)
  return { value: criticalityToUse, label: oldNonConformityTranslation[criticalityToUse] }
}

export const getIfNonConformityNeedActionPlan = (criticalityUuid, type) => {
  const criticalityNeedActionPlan = defaultCriticalityNeedActionPlan.includes(criticalityUuid)
  const isAuditReco = type === "auditRecommendation"
  if (criticalityNeedActionPlan || isAuditReco) return true
  return false
}
